module.exports = __webpack_public_path__ + "static/media/image_33.401336c3.png";